
export const visionData = [
    {
        year: '2026',
        statusLabel: 'UPCOMING',
        heroImage: '/images/vision/2026.jpeg',
        subTitle: 'Provisional Calendar (Six Rounds)',
        rounds: [
            { id: 'R1', month: 'April', dates: '11 - 12', location: 'KYRGYZSTAN', flag: '🇰🇬' },
            { id: 'R2', month: 'Sept', dates: '05 - 06', location: 'UZBEKISTAN', flag: '🇺🇿' },
            { id: 'R3', month: 'Oct', dates: '17 - 18', location: 'HONG KONG', flag: '🇭🇰' },
            { id: 'R4', month: 'Oct', dates: '23 - 25', location: 'THAILAND', flag: '🇹🇭' },
            { id: 'R5', month: 'Nov', dates: 'TBD', location: 'INDIA', flag: '🇮🇳' },
            { id: 'R6', month: 'Dec', dates: '26 - 27', location: 'CHINESE TAIPEI', flag: '🇹🇼' },
        ],
    },
    {
        year: '2025',
        statusLabel: 'RECAP',
        subTitle: 'Championship Recap',
        heroImage: '/images/vision/2025.jpeg',
        rounds: [
            { id: 'R1', month: 'June', dates: '31 - 01', location: 'KYRGYZSTAN', flag: '🇰🇬' },
            { id: 'R2', month: 'Sept', dates: '26 - 28', location: 'SRILANKA', flag: '🇱🇰' },
            { id: 'R3', month: 'Nov', dates: '01 - 02', location: 'INDIA', flag: '🇮🇳' },
            { id: 'R4', month: 'Nov', dates: '22 - 23', location: 'TAIPEI', flag: '🇹🇼' },
            { id: 'R5', month: 'Dec', dates: 'TBD', location: 'UZBEKISTAN', flag: '🇺🇿' },
        ],
    }
];
